// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hard Reset */
html, body {
	height:100%;
	margin: 0;
	padding: 0;
	overflow: hidden;
}

html {
	font-size: 62.5%;
	-webkit-font-smoothing: antialiased;
}

body {
	height: 100%;
	/*background: #e2e3e6;*/
	font-family: "Roboto", "sans-serif";
}

h2 {
	font-family: "Roboto", "sans-serif";
	font-size: 18px;
	font-size: 1.8rem;
	font-weight: 500;
}

h3 {
	font-family: "Roboto", "sans-serif";
	font-size: 16px;
	font-size: 1.6rem;
	font-weight: 500;
}

h4 {
	font-family: "Roboto", "sans-serif";
	font-size: 16px;
	font-size: 1.6rem;
	font-weight: 500;
}

.navbar {
	margin-bottom: 0px;
}

.group {
	height: 100%;

}

.editor-content {
	display: table;
	table-layout: fixed;
	margin-bottom: -20px;
}

.editor-layout {
	height: 100%;
	width:100%;
	min-width: 1000px;
}

.editor-pane {
	height: 100%;
	background: #e2e3e6;
	width: 100%;
	max-width: 400px;
	min-width: 100px;
	overflow: hidden;
	vertical-align: top; 
	min-height: 100px; 
}

.layout-frame {
	height: 100%; 
	width: 100%; 
	position: relative;
	min-width: 575px; 
	display: -ms-flexbox;      
	display: -webkit-flex;
	display: flex;
}

.row-centered {
	text-align: center;
}

.col-centered {
	float: none;
	margin: 0 auto;
}

/* Global elements */

li {
	margin: 0;
	padding: 0;
}

.help {
	position: absolute;
	top: 5px;
	right: 3px;
	padding: 3px 7px;
	background: #fcfcfc; /* Old browsers */
	background-image: -moz-linear-gradient(var(--gradient));
	background-image: -webkit-linear-gradient(var(--gradient));
	border: 1px solid #d5d5d5;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;

	color: white;

	width: 28px;
	height: 20px;
	background: linear-gradient(var(--gradient-ToBottom));
	font: normal normal normal 11px/1 FontAwesome;
}

.help:hover {
	color: #ffffff;
}

.help-tool-bar {
	top: 24px;
}

.help-search-tool {
	top: 6px;
}

/* Buttons */
.editor-layout .btn {

	padding: 4px 12px;
	border-radius: 3px;
	-moz-border-radius: 3px;
	-webkit-border-radius: 3px;

	box-shadow: 0px 2px 3px grey;
	-moz-box-shadow: 0px 2px 3px grey;
	-webkit-box-shadow: 0px 2px 3px grey;

	font-family: "Roboto", "sans-serif";
	font-size: 11px;
	font-size: 1.1rem;
}

.btn-default {
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */

	border: 1px solid #d5d5d5;

	box-shadow: 0px 2px 5px #d5d5d5;
	-moz-box-shadow: 0px 2px 5px #d5d5d5;
	-webkit-box-shadow: 0px 2px 5px #d5d5d5;

	

	color: #333;
	font-weight: 700;
}

.btn-default:hover {
	border-color: #d5d5d5;
}

/* Search box */
.search-box, input[type="text"], input[type=number] {
	width: 100%;
	padding: 5px 2px 5px 3px;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;

	border: 1px solid #d5d5d5;

	box-shadow: none;
	-moz-box-shadow: none;
	-webkit-box-shadow: none;

	color: #949494;
	font-family: "Roboto", "sans-serif";
	font-weight: 400;
}

.search-box:focus, input[type="text"]:focus, input[type=number]:focus {
	color: #333333;
	outline: none;
	border-color: #bbb;
	box-shadow: none;
	-moz-box-shadow: none;
	-webkit-box-shadow: none;
}

/* Styled select box */
.dropdown {
	position: relative;
	margin-top: 0px;
}

.dropdown-toggle {
	width: 100%;
	text-overflow: ellipsis;
}

.dropdown button {
	background: white;
	width: 100%;
	padding: 5px 0px 5px 8px;
	border: 1px solid #bbb;
	font-family: "Roboto", "sans-serif";
	font-weight: 400;
	font-size: 14px;
	font-size: 1.4rem;
	color: #333;
	border-radius: 4px;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;
	text-align: left;
}

.dropdown .caret {
	float: right;
	margin: 8px 12px 0 0;
}

.dropdown .dropdown-menu {
	width: 100%;
}

.dropdown .dropdown-menu li {
	font-size: 14px;
	font-size: 1.4rem;
}

.dropdown .dropdown-menu a:hover {
	background: #86b823;
	color: #fff;
}

.dropdown-menu > li > a {
	padding: 3px 18px !important;
}

.dropdown-menu::before {
	position: absolute;
	top: -7px;
	right: 9px;
	display: inline-block;
	border-right: 7px solid transparent;
	border-bottom: 7px solid #d5d5d5;
	border-left: 7px solid transparent;
	border-top: 0px;
	border-bottom-color: rgba(0, 0, 0, 0.2);
	content: '';
}

.dropdown-menu::after {
	position: absolute;
	top: -6px;
	right: 10px;
	display: inline-block;
	border-right: 6px solid transparent;
	border-bottom: 6px solid white;
	border-left: 6px solid transparent;
	border-top: 0px;
	content: '';
}

.navbar .navbar-right > li > .dropdown-menu:before,
.navbar .nav > li > .dropdown-menu.navbar-right:before {
	right: 12px; left: auto;
}

.navbar .navbar-right > li > .dropdown-menu:after,
.navbar .nav > li > .dropdown-menu.navbar-right:after {
	right: 13px; left: auto;
}

/* Draggable */
.draggable:hover {
	cursor: move;
}

/* Tabbed Content */
.tab-content {
	position: relative;
	background: #fff;
	border-left: 1px solid #d5d5d5;
	border-bottom: 1px solid #d5d5d5;
	border-right: 1px solid #d5d5d5;
	border-radius: 0px 0px 4px 4px;
	-moz-border-radius: 0px 0px 4px 4px;
	-webkit-border-radius: 0px 0px 4px 4px;
}

.tab-content > .tab-pane, .pill-content > .pill-pane {
	padding: 15px 12px;
}

.tab-content-notifications-modal{
	height: 155px;
	display: inline-flex;
	width: 100%;
	border-top: 1px solid #ddd;
}

.notification-content-dashboard{
	font: 12px Roboto, sans-serif;
	height: 300px;
	overflow: auto;
	margin-right: 15px;
}

.nav-tabs > li > a {
	margin-right: 0px;

	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */

	border-right: 1px solid #d5d5d5 !important;
	border-bottom: 1px solid #d5d5d5;

	color: #333;
}

/*.nav-tabs > li:first-child > a {
	border-left: 1px solid #d5d5d5;
	border-right: 0px;
}*/

.nav-tabs > li > a {
	border-radius: 0px 0 0 0 !important;
	-moz-border-radius: 0px 0 0 0 !important;
	-webkit-border-radius: 0px 0 0 0 !important;
}

.nav-tabs > li > a:hover {
	color:  var(--main-primary);
	font-weight: 500;
}

.nav-tabs > li:first-child > a {
	border-radius: 4px 0 0 0 !important;
	-moz-border-radius: 4px 0 0 0 !important;
	-webkit-border-radius: 4px 0 0 0 !important;
	border-left: 1px solid #d5d5d5;
}

.nav-tabs > li:last-child > a {
	border-radius: 0px 4px 0 0px !important;
	-moz-border-radius: 0px 4px 0 0px !important;
	-webkit-border-radius: 0px 4px 0 0px !important;
}

.nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {
	background: #eeeeee; /* Old browsers */
	background: -moz-linear-gradient(top,  #eeeeee 0%, #fff 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #eeeeee 0%,#fff 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #eeeeee 0%,#fff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#eeeeee', endColorstr='#fcfcfc',GradientType=0 ); /* IE6-9 */

	border-bottom-color: #fcfcfc;

	color:  var(--main-primary);
	font-weight: 500;
}

.filter-input-icon{
	display: table-cell;
	width: 1%;
	vertical-align: middle;
	white-space: nowrap;
	padding: 0;
}

.input-group-addon {
 	/* padding: 6px 12px 6px 0px; */
	padding: 0px;
}

/*.nav-tabs > li:first-child.active > a {
	border-right: 1px solid #d5d5d5;
}*/

.nopadding {
	padding: 0 !important;
	margin: 0 !important;
}

.nopadding-l {
	padding-left: 0px !important;
	margin-left: 0px !important;
}

.nopadding-r {
	padding-right: 0px !important;
	margin-right: 0px !important;
}


.strong {
	font-weight: bold !important;
}

/*.icon-gradient:before {
	background: -webkit-gradient(linear, left top, left bottom, from(#9e9e9e), to(#777));
	    -webkit-background-clip: text;
	    -webkit-text-fill-color: transparent;
		text-shadow: 0px 1px 2px rgba(0,0,0,0.2);
}*/

/* Alerts */

.alert-container {
	position: absolute;
	width: 98%;
	top: 10px;
	left: 0px;
	z-index: 100;
}

.alert {
	display: table !important;

	margin: 15px auto;
	padding: 0;

	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */

	border: #d5d5d5;

}

.alert-icon {
	display: table-cell;
	width: 57px;
	height: 100%;
	margin-right: 20px;
	padding: 10px;
	font-size: 3.0rem;
	font-size: 30px;
	text-align: center;
	vertical-align: middle;
}

.alert-content {
	display: table-cell;
	padding: 10px;
	font-size: 1.4rem;
	font-size: 14px;
	vertical-align: middle;
}

.alert-close {
	display: table-cell;
	vertical-align: top;
}

.alert-dismissable .close, .alert-dismissible .close {
	top: 2px;
	right: 10px;
}


.alert-warning {
	width: 30%;
	border: 1px solid #938f23 !important;
	box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);
	color: #333;
}

.alert-warning .alert-icon {
	background: rgba(147,143,35, 0.10);
	color: #807d2c;
}

.alert-danger {
	width: 30%;
	border: 1px solid #a73837 !important;
	box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);
	color: #333;
}

.alert-danger .alert-icon {
	background: rgba(231,67,67,0.10);
	color: #7d2a2a;
}

.alert-success {
	width: 30%;
	border: 1px solid #5e8c26 !important;
	box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);
	color: #333;
}

.alert-success .alert-icon {
	background: rgba(94,140,38,0.10);
	color: #497c30;
}

.alert-info {
	width: 30%;
	border: 1px solid #2d84a4;
	box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);
	color: #333;
}

.alert-info .alert-icon {
	background: rgba(45,132,164, 0.10);
	color: #246a84;
}

.alert-view {
	border: 1px solid #cc7929;
	box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);
	color: #333;
}

.alert-view .alert-icon {
	background: rgba(204,121,41, 0.10);
	color: #b76d25;
}

.error-warning {
	position: absolute;
	bottom: 20px;
	font-size: smaller;
	color: #ff0000;
	display: none;
}


.disable-select {
  -webkit-user-select: none;  
  -moz-user-select: none;    
  -ms-user-select: none;      
  user-select: none;
}

.trim-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 1px;
  padding-right: 3px;
}`, "",{"version":3,"sources":["webpack://./assets/style/partials/global.css"],"names":[],"mappings":"AAAA,eAAe;AACf;CACC,WAAW;CACX,SAAS;CACT,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;AACpC;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,mCAAmC;AACpC;;AAEA;CACC,mCAAmC;CACnC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;;AAEb;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;CACpB,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA,oBAAoB;;AAEpB;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,gBAAgB;CAChB,mBAAmB,EAAE,iBAAiB;CACtC,uDAAuD;CACvD,0DAA0D;CAC1D,yBAAyB;CACzB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,YAAY;;CAEZ,WAAW;CACX,YAAY;CACZ,qDAAqD;CACrD,6CAA6C;AAC9C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,QAAQ;AACT;;AAEA,YAAY;AACZ;;CAEC,iBAAiB;CACjB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,4BAA4B;CAC5B,iCAAiC;CACjC,oCAAoC;;CAEpC,mCAAmC;CACnC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;;CAE/H,yBAAyB;;CAEzB,+BAA+B;CAC/B,oCAAoC;CACpC,uCAAuC;;;;CAIvC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA,eAAe;AACf;CACC,WAAW;CACX,wBAAwB;CACxB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,yBAAyB;;CAEzB,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;;CAExB,cAAc;CACd,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA,sBAAsB;AACtB;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,wBAAwB;CACxB,sBAAsB;CACtB,mCAAmC;CACnC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,0BAA0B;CAC1B,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,qBAAqB;CACrB,mCAAmC;CACnC,gCAAgC;CAChC,kCAAkC;CAClC,eAAe;CACf,uCAAuC;CACvC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,qBAAqB;CACrB,mCAAmC;CACnC,8BAA8B;CAC9B,kCAAkC;CAClC,eAAe;CACf,WAAW;AACZ;;AAEA;;CAEC,WAAW,EAAE,UAAU;AACxB;;AAEA;;CAEC,WAAW,EAAE,UAAU;AACxB;;AAEA,cAAc;AACd;CACC,YAAY;AACb;;AAEA,mBAAmB;AACnB;CACC,kBAAkB;CAClB,gBAAgB;CAChB,8BAA8B;CAC9B,gCAAgC;CAChC,+BAA+B;CAC/B,8BAA8B;CAC9B,mCAAmC;CACnC,sCAAsC;AACvC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,WAAW;CACX,0BAA0B;AAC3B;;AAEA;CACC,6BAA6B;CAC7B,aAAa;CACb,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;;CAEjB,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;;CAE/H,0CAA0C;CAC1C,gCAAgC;;CAEhC,WAAW;AACZ;;AAEA;;;EAGE;;AAEF;CACC,mCAAmC;CACnC,wCAAwC;CACxC,2CAA2C;AAC5C;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,wCAAwC;CACxC,2CAA2C;CAC3C,8BAA8B;AAC/B;;AAEA;CACC,uCAAuC;CACvC,4CAA4C;CAC5C,+CAA+C;AAChD;;AAEA;CACC,mBAAmB,EAAE,iBAAiB;CACtC,6DAA6D,EAAE,aAAa;CAC5E,+DAA+D,EAAE,4BAA4B;CAC7F,6DAA6D,EAAE,qDAAqD;CACpH,mHAAmH,EAAE,UAAU;;CAE/H,4BAA4B;;CAE5B,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,SAAS;CACT,sBAAsB;CACtB,mBAAmB;CACnB,UAAU;AACX;;AAEA;EACE,+BAA+B;CAChC,YAAY;AACb;;AAEA;;EAEE;;AAEF;CACC,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,6BAA6B;CAC7B,4BAA4B;AAC7B;;;AAGA;CACC,4BAA4B;AAC7B;;AAEA;;;;;EAKE;;AAEF,WAAW;;AAEX;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,SAAS;CACT,YAAY;AACb;;AAEA;CACC,yBAAyB;;CAEzB,iBAAiB;CACjB,UAAU;;CAEV,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;;CAE/H,eAAe;;AAEhB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,iBAAiB;CACjB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,QAAQ;CACR,WAAW;AACZ;;;AAGA;CACC,UAAU;CACV,oCAAoC;CACpC,+CAA+C;CAC/C,oDAAoD;CACpD,uDAAuD;CACvD,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,oCAAoC;CACpC,gDAAgD;CAChD,qDAAqD;CACrD,wDAAwD;CACxD,WAAW;AACZ;;AAEA;CACC,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,oCAAoC;CACpC,+CAA+C;CAC/C,oDAAoD;CACpD,uDAAuD;CACvD,WAAW;AACZ;;AAEA;CACC,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,yBAAyB;CACzB,gDAAgD;CAChD,qDAAqD;CACrD,wDAAwD;CACxD,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,8CAA8C;CAC9C,mDAAmD;CACnD,sDAAsD;CACtD,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,aAAa;AACd;;;AAGA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Hard Reset */\r\nhtml, body {\r\n\theight:100%;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\toverflow: hidden;\r\n}\r\n\r\nhtml {\r\n\tfont-size: 62.5%;\r\n\t-webkit-font-smoothing: antialiased;\r\n}\r\n\r\nbody {\r\n\theight: 100%;\r\n\t/*background: #e2e3e6;*/\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n}\r\n\r\nh2 {\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 18px;\r\n\tfont-size: 1.8rem;\r\n\tfont-weight: 500;\r\n}\r\n\r\nh3 {\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 16px;\r\n\tfont-size: 1.6rem;\r\n\tfont-weight: 500;\r\n}\r\n\r\nh4 {\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 16px;\r\n\tfont-size: 1.6rem;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.navbar {\r\n\tmargin-bottom: 0px;\r\n}\r\n\r\n.group {\r\n\theight: 100%;\r\n\r\n}\r\n\r\n.editor-content {\r\n\tdisplay: table;\r\n\ttable-layout: fixed;\r\n\tmargin-bottom: -20px;\r\n}\r\n\r\n.editor-layout {\r\n\theight: 100%;\r\n\twidth:100%;\r\n\tmin-width: 1000px;\r\n}\r\n\r\n.editor-pane {\r\n\theight: 100%;\r\n\tbackground: #e2e3e6;\r\n\twidth: 100%;\r\n\tmax-width: 400px;\r\n\tmin-width: 100px;\r\n\toverflow: hidden;\r\n\tvertical-align: top; \r\n\tmin-height: 100px; \r\n}\r\n\r\n.layout-frame {\r\n\theight: 100%; \r\n\twidth: 100%; \r\n\tposition: relative;\r\n\tmin-width: 575px; \r\n\tdisplay: -ms-flexbox;      \r\n\tdisplay: -webkit-flex;\r\n\tdisplay: flex;\r\n}\r\n\r\n.row-centered {\r\n\ttext-align: center;\r\n}\r\n\r\n.col-centered {\r\n\tfloat: none;\r\n\tmargin: 0 auto;\r\n}\r\n\r\n/* Global elements */\r\n\r\nli {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.help {\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tright: 3px;\r\n\tpadding: 3px 7px;\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground-image: -moz-linear-gradient(var(--gradient));\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient));\r\n\tborder: 1px solid #d5d5d5;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\r\n\tcolor: white;\r\n\r\n\twidth: 28px;\r\n\theight: 20px;\r\n\tbackground: linear-gradient(var(--gradient-ToBottom));\r\n\tfont: normal normal normal 11px/1 FontAwesome;\r\n}\r\n\r\n.help:hover {\r\n\tcolor: #ffffff;\r\n}\r\n\r\n.help-tool-bar {\r\n\ttop: 24px;\r\n}\r\n\r\n.help-search-tool {\r\n\ttop: 6px;\r\n}\r\n\r\n/* Buttons */\r\n.editor-layout .btn {\r\n\r\n\tpadding: 4px 12px;\r\n\tborder-radius: 3px;\r\n\t-moz-border-radius: 3px;\r\n\t-webkit-border-radius: 3px;\r\n\r\n\tbox-shadow: 0px 2px 3px grey;\r\n\t-moz-box-shadow: 0px 2px 3px grey;\r\n\t-webkit-box-shadow: 0px 2px 3px grey;\r\n\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 11px;\r\n\tfont-size: 1.1rem;\r\n}\r\n\r\n.btn-default {\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\r\n\tborder: 1px solid #d5d5d5;\r\n\r\n\tbox-shadow: 0px 2px 5px #d5d5d5;\r\n\t-moz-box-shadow: 0px 2px 5px #d5d5d5;\r\n\t-webkit-box-shadow: 0px 2px 5px #d5d5d5;\r\n\r\n\t\r\n\r\n\tcolor: #333;\r\n\tfont-weight: 700;\r\n}\r\n\r\n.btn-default:hover {\r\n\tborder-color: #d5d5d5;\r\n}\r\n\r\n/* Search box */\r\n.search-box, input[type=\"text\"], input[type=number] {\r\n\twidth: 100%;\r\n\tpadding: 5px 2px 5px 3px;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\r\n\tborder: 1px solid #d5d5d5;\r\n\r\n\tbox-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\t-webkit-box-shadow: none;\r\n\r\n\tcolor: #949494;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 400;\r\n}\r\n\r\n.search-box:focus, input[type=\"text\"]:focus, input[type=number]:focus {\r\n\tcolor: #333333;\r\n\toutline: none;\r\n\tborder-color: #bbb;\r\n\tbox-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\t-webkit-box-shadow: none;\r\n}\r\n\r\n/* Styled select box */\r\n.dropdown {\r\n\tposition: relative;\r\n\tmargin-top: 0px;\r\n}\r\n\r\n.dropdown-toggle {\r\n\twidth: 100%;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.dropdown button {\r\n\tbackground: white;\r\n\twidth: 100%;\r\n\tpadding: 5px 0px 5px 8px;\r\n\tborder: 1px solid #bbb;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 400;\r\n\tfont-size: 14px;\r\n\tfont-size: 1.4rem;\r\n\tcolor: #333;\r\n\tborder-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\ttext-align: left;\r\n}\r\n\r\n.dropdown .caret {\r\n\tfloat: right;\r\n\tmargin: 8px 12px 0 0;\r\n}\r\n\r\n.dropdown .dropdown-menu {\r\n\twidth: 100%;\r\n}\r\n\r\n.dropdown .dropdown-menu li {\r\n\tfont-size: 14px;\r\n\tfont-size: 1.4rem;\r\n}\r\n\r\n.dropdown .dropdown-menu a:hover {\r\n\tbackground: #86b823;\r\n\tcolor: #fff;\r\n}\r\n\r\n.dropdown-menu > li > a {\r\n\tpadding: 3px 18px !important;\r\n}\r\n\r\n.dropdown-menu::before {\r\n\tposition: absolute;\r\n\ttop: -7px;\r\n\tright: 9px;\r\n\tdisplay: inline-block;\r\n\tborder-right: 7px solid transparent;\r\n\tborder-bottom: 7px solid #d5d5d5;\r\n\tborder-left: 7px solid transparent;\r\n\tborder-top: 0px;\r\n\tborder-bottom-color: rgba(0, 0, 0, 0.2);\r\n\tcontent: '';\r\n}\r\n\r\n.dropdown-menu::after {\r\n\tposition: absolute;\r\n\ttop: -6px;\r\n\tright: 10px;\r\n\tdisplay: inline-block;\r\n\tborder-right: 6px solid transparent;\r\n\tborder-bottom: 6px solid white;\r\n\tborder-left: 6px solid transparent;\r\n\tborder-top: 0px;\r\n\tcontent: '';\r\n}\r\n\r\n.navbar .navbar-right > li > .dropdown-menu:before,\r\n.navbar .nav > li > .dropdown-menu.navbar-right:before {\r\n\tright: 12px; left: auto;\r\n}\r\n\r\n.navbar .navbar-right > li > .dropdown-menu:after,\r\n.navbar .nav > li > .dropdown-menu.navbar-right:after {\r\n\tright: 13px; left: auto;\r\n}\r\n\r\n/* Draggable */\r\n.draggable:hover {\r\n\tcursor: move;\r\n}\r\n\r\n/* Tabbed Content */\r\n.tab-content {\r\n\tposition: relative;\r\n\tbackground: #fff;\r\n\tborder-left: 1px solid #d5d5d5;\r\n\tborder-bottom: 1px solid #d5d5d5;\r\n\tborder-right: 1px solid #d5d5d5;\r\n\tborder-radius: 0px 0px 4px 4px;\r\n\t-moz-border-radius: 0px 0px 4px 4px;\r\n\t-webkit-border-radius: 0px 0px 4px 4px;\r\n}\r\n\r\n.tab-content > .tab-pane, .pill-content > .pill-pane {\r\n\tpadding: 15px 12px;\r\n}\r\n\r\n.tab-content-notifications-modal{\r\n\theight: 155px;\r\n\tdisplay: inline-flex;\r\n\twidth: 100%;\r\n\tborder-top: 1px solid #ddd;\r\n}\r\n\r\n.notification-content-dashboard{\r\n\tfont: 12px Roboto, sans-serif;\r\n\theight: 300px;\r\n\toverflow: auto;\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.nav-tabs > li > a {\r\n\tmargin-right: 0px;\r\n\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\r\n\tborder-right: 1px solid #d5d5d5 !important;\r\n\tborder-bottom: 1px solid #d5d5d5;\r\n\r\n\tcolor: #333;\r\n}\r\n\r\n/*.nav-tabs > li:first-child > a {\r\n\tborder-left: 1px solid #d5d5d5;\r\n\tborder-right: 0px;\r\n}*/\r\n\r\n.nav-tabs > li > a {\r\n\tborder-radius: 0px 0 0 0 !important;\r\n\t-moz-border-radius: 0px 0 0 0 !important;\r\n\t-webkit-border-radius: 0px 0 0 0 !important;\r\n}\r\n\r\n.nav-tabs > li > a:hover {\r\n\tcolor:  var(--main-primary);\r\n\tfont-weight: 500;\r\n}\r\n\r\n.nav-tabs > li:first-child > a {\r\n\tborder-radius: 4px 0 0 0 !important;\r\n\t-moz-border-radius: 4px 0 0 0 !important;\r\n\t-webkit-border-radius: 4px 0 0 0 !important;\r\n\tborder-left: 1px solid #d5d5d5;\r\n}\r\n\r\n.nav-tabs > li:last-child > a {\r\n\tborder-radius: 0px 4px 0 0px !important;\r\n\t-moz-border-radius: 0px 4px 0 0px !important;\r\n\t-webkit-border-radius: 0px 4px 0 0px !important;\r\n}\r\n\r\n.nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {\r\n\tbackground: #eeeeee; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #eeeeee 0%, #fff 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #eeeeee 0%,#fff 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #eeeeee 0%,#fff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#eeeeee', endColorstr='#fcfcfc',GradientType=0 ); /* IE6-9 */\r\n\r\n\tborder-bottom-color: #fcfcfc;\r\n\r\n\tcolor:  var(--main-primary);\r\n\tfont-weight: 500;\r\n}\r\n\r\n.filter-input-icon{\r\n\tdisplay: table-cell;\r\n\twidth: 1%;\r\n\tvertical-align: middle;\r\n\twhite-space: nowrap;\r\n\tpadding: 0;\r\n}\r\n\r\n.input-group-addon {\r\n \t/* padding: 6px 12px 6px 0px; */\r\n\tpadding: 0px;\r\n}\r\n\r\n/*.nav-tabs > li:first-child.active > a {\r\n\tborder-right: 1px solid #d5d5d5;\r\n}*/\r\n\r\n.nopadding {\r\n\tpadding: 0 !important;\r\n\tmargin: 0 !important;\r\n}\r\n\r\n.nopadding-l {\r\n\tpadding-left: 0px !important;\r\n\tmargin-left: 0px !important;\r\n}\r\n\r\n.nopadding-r {\r\n\tpadding-right: 0px !important;\r\n\tmargin-right: 0px !important;\r\n}\r\n\r\n\r\n.strong {\r\n\tfont-weight: bold !important;\r\n}\r\n\r\n/*.icon-gradient:before {\r\n\tbackground: -webkit-gradient(linear, left top, left bottom, from(#9e9e9e), to(#777));\r\n\t    -webkit-background-clip: text;\r\n\t    -webkit-text-fill-color: transparent;\r\n\t\ttext-shadow: 0px 1px 2px rgba(0,0,0,0.2);\r\n}*/\r\n\r\n/* Alerts */\r\n\r\n.alert-container {\r\n\tposition: absolute;\r\n\twidth: 98%;\r\n\ttop: 10px;\r\n\tleft: 0px;\r\n\tz-index: 100;\r\n}\r\n\r\n.alert {\r\n\tdisplay: table !important;\r\n\r\n\tmargin: 15px auto;\r\n\tpadding: 0;\r\n\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\r\n\tborder: #d5d5d5;\r\n\r\n}\r\n\r\n.alert-icon {\r\n\tdisplay: table-cell;\r\n\twidth: 57px;\r\n\theight: 100%;\r\n\tmargin-right: 20px;\r\n\tpadding: 10px;\r\n\tfont-size: 3.0rem;\r\n\tfont-size: 30px;\r\n\ttext-align: center;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.alert-content {\r\n\tdisplay: table-cell;\r\n\tpadding: 10px;\r\n\tfont-size: 1.4rem;\r\n\tfont-size: 14px;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.alert-close {\r\n\tdisplay: table-cell;\r\n\tvertical-align: top;\r\n}\r\n\r\n.alert-dismissable .close, .alert-dismissible .close {\r\n\ttop: 2px;\r\n\tright: 10px;\r\n}\r\n\r\n\r\n.alert-warning {\r\n\twidth: 30%;\r\n\tborder: 1px solid #938f23 !important;\r\n\tbox-shadow: 0px 0px 20px rgba(143,141,90, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-warning .alert-icon {\r\n\tbackground: rgba(147,143,35, 0.10);\r\n\tcolor: #807d2c;\r\n}\r\n\r\n.alert-danger {\r\n\twidth: 30%;\r\n\tborder: 1px solid #a73837 !important;\r\n\tbox-shadow: 0px 0px 20px rgba(167,122,123, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-danger .alert-icon {\r\n\tbackground: rgba(231,67,67,0.10);\r\n\tcolor: #7d2a2a;\r\n}\r\n\r\n.alert-success {\r\n\twidth: 30%;\r\n\tborder: 1px solid #5e8c26 !important;\r\n\tbox-shadow: 0px 0px 20px rgba(121,139,99, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-success .alert-icon {\r\n\tbackground: rgba(94,140,38,0.10);\r\n\tcolor: #497c30;\r\n}\r\n\r\n.alert-info {\r\n\twidth: 30%;\r\n\tborder: 1px solid #2d84a4;\r\n\tbox-shadow: 0px 0px 20px rgba(116,149,161, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-info .alert-icon {\r\n\tbackground: rgba(45,132,164, 0.10);\r\n\tcolor: #246a84;\r\n}\r\n\r\n.alert-view {\r\n\tborder: 1px solid #cc7929;\r\n\tbox-shadow: 0px 0px 20px rgba(136,88,43, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-view .alert-icon {\r\n\tbackground: rgba(204,121,41, 0.10);\r\n\tcolor: #b76d25;\r\n}\r\n\r\n.error-warning {\r\n\tposition: absolute;\r\n\tbottom: 20px;\r\n\tfont-size: smaller;\r\n\tcolor: #ff0000;\r\n\tdisplay: none;\r\n}\r\n\r\n\r\n.disable-select {\r\n  -webkit-user-select: none;  \r\n  -moz-user-select: none;    \r\n  -ms-user-select: none;      \r\n  user-select: none;\r\n}\r\n\r\n.trim-text {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  padding-left: 1px;\r\n  padding-right: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
